var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main",attrs:{"role":"main"}},[_c('Leaflets'),_c('QRCode'),_c('Navbar'),_c('ExInformation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }